import styled from 'styled-components';

export const EditAssetDrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .asset-details-tabs {
    height: 100%;
    > div:last-child > div:last-child {
      height: 100%;
      > div {
        height: 100%;
      }
    }
  }

  .header {
    padding: ${({ theme: { token } }) => token.padding}px;
    align-self: flex-end;
  }

  .body-header {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    margin-left: ${({ theme: { token } }) => token.marginSM}px;
  }
`;
